export default {
  title: 'リンク名',
  url: 'URL',
};
